<template>
  <div class="team-form-member">
    <div class="remove">
      <a href @click.prevent><i class="ion ion-drag" /></a>
      <a @click.prevent="removeMember(index)"><i class="ion ion-close" /></a>
    </div>
    <div class="member-wrapper">
      <div class="member-profile">
        <vb-uploader
          class="image-wrapper"
          @upload-done="update('image_url', $event, index)"
        >
          <div
            v-show="memberObj.image_url"
            class="img-cropped centered"
            :style="{ 'background-image': `url(${memberObj.image_url})` }"
          />
          <img-placeholder
            v-show="!memberObj.image_url"
            class="img-responsive centered"
            width="120"
            height="120"
          />
        </vb-uploader>

        <div class="social-wrapper">
          <div class="form-social">
            <i class="ion ion-social-twitter" />
            <el-input
              v-model="memberObj.twitter_url"
              placeholder="Paste twitter link"
              @blur="update('twitter_url', $event, index)"
            />
          </div>
          <div class="form-social">
            <i class="ion ion-social-facebook" />
            <el-input
              v-model="memberObj.facebook_url"
              placeholder="Paste facebook link"
              @blur="update('facebook_url', $event, index)"
            />
          </div>
          <div class="form-social">
            <i class="ion ion-social-linkedin" />
            <el-input
              v-model="memberObj.linkedin_url"
              placeholder="Paste linkedin link"
              @blur="update('linkedin_url', $event, index)"
            />
          </div>
        </div>
      </div>

      <div class="bio">
        <form class="avatar-caption">
          <div class="form-group">
            <el-input
              v-model="memberObj.name"
              placeholder="First Name and Last Name"
              type="text"
              class="centered"
              :class="{ 'has-errors': errors.name }"
              @blur="update('name', $event, index)"
            />
          </div>
          <div class="form-group">
            <el-input
              v-model="memberObj.title"
              placeholder="Job Title"
              type="text"
              class="centered"
              :class="{ 'has-errors': errors.title }"
              @blur="update('title', $event, index)"
            />
          </div>
        </form>
        <el-input
          id="member-bio"
          v-model="memberObj.bio"
          type="textarea"
          :class="{ 'has-errors': errors.bio }"
          placeholder="Biography"
          rows="10"
          maxlength="300"
          show-word-limit
          @blur="update('bio', $event, index)"
        />
      </div>
    </div>
  </div>
</template>

<script>
import Store from '@/store'

const EMPTY_MEMBER = {
  name: '',
  title: '',
  bio: null,
  image_url: null,
  linkedin_url: null,
  facebook_url: null,
  twitter_url: null,
}

export default {
  props: {
    index: {
      type: Number,
      default: null,
    },
    member: {
      type: Object,
      default() {
        return { ...EMPTY_MEMBER }
      },
    },
    errors: {
      type: Object,
      default: () => ({}),
    },
  },
  setup(props) {
    const removeMember = (index) => {
      Store.commit('startupProfile/REMOVE_MEMBER', index)
    }

    const update = (property, event, index) => {
      const value =
        property === 'image_url' ? event.data.url : event.target.value

      if (value === props.member[property]) return

      Store.commit(`startupProfile/UPDATE_MEMBER_${property.toUpperCase()}`, {
        value,
        index,
      })
    }

    return { memberObj: props.member, removeMember, update }
  },
}
</script>

<style lang="scss">
@import '~assets/css/vars.scss';
@import '~assets/css/colors.scss';

.team-form-member {
  background-color: $white;
  padding: 20px;
  position: relative;

  &.sortable-ghost {
    background-color: $grey160;
  }

  .member-wrapper {
    display: flex;
  }

  .social-wrapper {
    margin-top: 30px;
  }

  .member-profile {
    margin-right: 20px;
  }

  .bio {
    flex-grow: 2;
  }

  .remove {
    cursor: pointer;
    position: absolute;
    right: 20px;
    z-index: 2000;
    display: none;

    a {
      margin-left: 5px;
    }
  }

  &:hover .remove {
    display: block;
  }

  .avatar-caption {
    float: left;
  }

  label {
    font-weight: normal;
  }

  .image-wrapper {
    margin: auto;
    margin-bottom: 10px;
    max-width: 120px;

    .img-cropped {
      background-repeat: no-repeat;
      background-position: center;
      background-size: cover;
      width: 120px;
      height: 120px;
      -webkit-border-radius: 60px;
      -moz-border-radius: 60px;
      border-radius: 50%;
      border: none;
    }

    img {
      max-width: 120px;
      max-height: 120px;
      border-radius: 50%;
    }
  }

  input,
  textarea {
    border-radius: 0;
    border: none;
    border-bottom: 1px solid $primary-lighter;
    transition: border-color 0.3s ease;

    &:focus {
      border: none;
      border-bottom: 1px solid $brand-primary;
      box-shadow: none;
    }

    background-color: transparent;
  }

  textarea {
    text-align: justify;
  }

  input {
    text-align: center;
    outline: none;
  }

  .form-social {
    display: grid;
    text-align: center;
    margin-bottom: 34px;

    .ion {
      margin-right: 5px;
    }

    input {
      text-align: left;
    }
  }

  textarea {
    width: 100%;
    height: 69%;
    outline: none;
  }
}
</style>
